/**
 * @file messages.tsx
 *
 * @fileoverview Custom hook to register messages in the global context.
 */

import { Message } from '../models/app';
import { useStore } from '~/jobiqo/context/state';

export interface MessageDispatchEvent {
  type: 'addMessage' | 'removeMessage';
  message: Message;
}

export interface MessageService {
  addMessage: (message: Message) => void;
  removeMessage: (message: Message) => void;
  messages: Message[];
}
export const useMessages = (): MessageService => {
  const { state, dispatch } = useStore();
  const stateMessages: Message[] =
    state && state.messages ? state.messages : [];
  return {
    addMessage: (message: Message) => {
      dispatch({ type: 'addMessage', message });
    },
    removeMessage: (message: Message) => {
      dispatch({ type: 'addMessage', message });
    },
    messages: stateMessages,
  };
};
